import * as React from 'react';
import { clsx } from 'clsx';

import * as style from './TableRow.css';

export interface ITableRowProps {
  fullWidth?: boolean;
  hover?: boolean;
}

export const TableRowComponent = React.forwardRef<HTMLTableRowElement, React.PropsWithChildren<ITableRowProps>>(
  (props, ref) => {
    const { children, hover } = props;

    return (
      <tr ref={ref} className={clsx(style['row'], hover && style['row--hovered'])}>
        {children}
      </tr>
    );
  },
);

TableRowComponent.displayName = 'TableRowComponent';

export const TableRow = React.memo(TableRowComponent);
